/** @jsx jsx */

import { formatDistanceToNowStrict } from 'date-fns';

import { css, jsx } from '@emotion/core';
import { Grid, Icon, Text, TooltipWrapper } from '@zapier/design-system';

import ZapCount from './ZapCount';

import type { Version } from './types';

const Styles = {
  tooltip: css`
    min-width: 200px;
  `,
  tooltipContainer: css`
    // Align info icon on Users column
    [class*='TooltipWrapper--non-interactive'] {
      display: flex !important;
      align-items: center !important;
    }
  `,
  userCount: css`
    align-items: center;
    display: flex;
    gap: 5px;
  `,
};

type Props = {
  integrationId: number;
  version: Version;
};

function ColumnActivity({ integrationId, version }: Props) {
  const hasCount =
    typeof version.userCount === 'number' && version.userCountUpdatedAt;

  return (
    <div css={Styles.tooltipContainer}>
      <Grid alignItems="center" columns="repeat(2, max-content)" gap="5px">
        <Icon name="personOneFill" size={16} />
        <TooltipWrapper
          allowMultilineTooltip={true}
          content={
            <div css={Styles.tooltip}>
              <Text color="inherit" fontWeight={600} margin="0 0 1rem" tag="p">
                Count of users who currently have a Zap turned on. These Zaps
                might not have generated tasks yet.
              </Text>
              <Text color="inherit" fontWeight={600} tag="p">
                {hasCount
                  ? `Updated ${formatDistanceToNowStrict(
                      version.userCountUpdatedAt * 1000,
                      { addSuffix: true }
                    )}.`
                  : 'The number is not available yet. Come back later.'}
              </Text>
            </div>
          }
        >
          {childProps => (
            <div css={Styles.userCount} {...childProps}>
              {hasCount ? (
                version.userCount
              ) : (
                <Icon name="alertInfo" size={16} />
              )}
            </div>
          )}
        </TooltipWrapper>
        <Icon name="miscBoltAltFill" size={16} />
        <ZapCount integrationId={integrationId} version={version.version} />
      </Grid>
    </div>
  );
}

export default ColumnActivity;
